import 'velocity-animate';

import $ from 'jquery';
import config from './globals/config';

export default function (
  trailerDrawerBG,
  trailerDrawerTitle,
  trailerDrawerInfoTitle,
  trailerDrawerDesktop,
  trailerDrawerInfoSeeMore,
  trailerDrawerInfoText
) {
  let currentTrailer = config.featuredTrailersJSON[config.currentTrailerNum];

  // set and reveal trailer drawer bg again
  trailerDrawerBG.css({ 'background-image': 'url(' + currentTrailer.trailer_drawer_image + ')' })
    .velocity({ opacity: 1 }, { duration: 300, complete: function () {} });

  // set drawer title and reveal
  trailerDrawerTitle.text(currentTrailer.post_title).velocity({ opacity: 1 }, { duration: 300 });

  // set drawer title inside drawer info
  trailerDrawerInfoTitle.text(currentTrailer.post_title);

  // set video id to data
  trailerDrawerDesktop.data('video-id', currentTrailer.bc_trailer_id);

  if (typeof(trailerDrawerInfoSeeMore) !== 'undefined') {
    trailerDrawerInfoSeeMore.attr('href', currentTrailer.post_url);
  }

  if (typeof(trailerDrawerInfoText) !== 'undefined') {
    trailerDrawerInfoText.text(currentTrailer.release_text_info);
  }

  let color = currentTrailer.color;

  $('.trailer-drawer .trailer-drawer-ui').removeClass(function (index, css) {
    return (css.match(/(^|\s)color-\S+/g) || []).join(' ');
  }).addClass('color-' + color);
}
